module.exports = __webpack_public_path__ + "static/media/win-reward-A01.2203383d.png";